import { atom } from "jotai";

export const romanizationPanelAtom = atom(false);
